export const ASSOCIATIONS_INITIAL_FORM = {
  nom_asso: "",
  categorie: "",
  description_asso: "",
  contact_asso: "",
  fonction_asso: "",
  tel_asso: "",
  mail_asso: "",
  website_asso: "",
  facebook_asso: "",
  logo_asso: "",
  adresse_asso: "",
  gps_asso: "",
  is_active: true,
};

export const ASSOCIATIONS_STATUS_OPTIONS = [
  {
    value: "all",
    label: "Toutes",
    description: "Afficher toutes les associations.",
  },
  {
    value: "active",
    label: "Publiées",
    description: "Visibles sur le site public.",
  },
  {
    value: "inactive",
    label: "Brouillons",
    description: "Masquées du site public.",
  },
];

export const ASSOCIATIONS_LOGO_OPTIONS = [
  {
    value: "all",
    label: "Tous",
  },
  {
    value: "yes",
    label: "Avec logo",
  },
  {
    value: "no",
    label: "Sans logo",
  },
];

export const ASSOCIATIONS_GPS_OPTIONS = [
  {
    value: "all",
    label: "Tous",
  },
  {
    value: "yes",
    label: "Avec GPS",
  },
];

export const ASSOCIATIONS_LIMIT_OPTIONS = [12, 24, 48, 96];

export const ASSOCIATION_CATEGORY_SUGGESTIONS = [
  "Sport",
  "Culture",
  "Solidarité",
  "Loisirs",
  "Patrimoine",
  "Jeunesse",
  "Seniors",
  "Environnement",
];

export const ASSOCIATIONS_FORM_HELPERS = [
  "Le nom de l’association est le seul champ obligatoire.",
  "Un logo rend la fiche plus identifiable pour les habitants.",
  "Les coordonnées GPS permettent d’afficher l’association sur une carte.",
];

export const ASSOCIATIONS_MEDIA_CATEGORY_DEFAULT = "associations";